import { gql } from '@/features/graphql/generated'

export const posOrderDraftMutation = gql(/* GraphQL */ `
    mutation PosOrderDraft($cartKey: ID!, $orderData: PosOrderDraftCreateInput!) {
        posOrderDraft(cartKey: $cartKey, orderData: $orderData) {
            ...OrderDraftPrices
        }
    }
`)

export const phoneOrderDraftMutation = gql(/* GraphQL */ `
    mutation PhoneOrderDraft($cartKey: ID!, $orderData: PhoneOrderDraftCreateInput!) {
        phoneOrderDraft(cartKey: $cartKey, orderData: $orderData) {
            ...OrderDraftPrices
        }
    }
`)

export const posOrderMutation = gql(/* GraphQL */ `
    mutation PosOrder($cartKey: ID!, $orderData: PosOrderCreateInput!) {
        posOrder(cartKey: $cartKey, orderData: $orderData) {
            uuid
        }
    }
`)

export const phoneOrderMutation = gql(/* GraphQL */ `
    mutation PhoneOrder($cartKey: ID!, $orderData: PhoneOrderCreateInput!) {
        phoneOrder(cartKey: $cartKey, orderData: $orderData) {
            uuid
        }
    }
`)

export const cartItemUpdateMutation = gql(/* GraphQL */ `
    mutation CartItemUpdate($cartKey: ID!, $itemUpdate: CartItemUpdateInput!) {
        cartItemUpdate(cartKey: $cartKey, itemUpdate: $itemUpdate) {
            ...CartItems
        }
    }
`)
